const GlobalConstants = require("./GlobalConstants.js");

const DefaultState = {
    Mode: GlobalConstants.Modes.Upload,
    SelectedFileType: null,
    FileTypes: {
        AreLoading: false,
        Data: null,
        LoadError: null
    },
    ValidExtensions: {
        AreLoading: false,
        Data: null,
        LoadError: null
    },
    SelectedFiles: [],
    Upload: {
        IsWorking: false,
        HasErrors: false
    },
    AuthResponse: null,
    History: {
        HasLoaded: false,
        IsLoading: false,
        Data: null,
        Error: null
    },
    AncientHistory: {
        HasLoaded: false,
        IsLoading: false,
        Error: null
    },
    Metadata: {
        CurrentSpec: null
    }
};

module.exports = DefaultState;


// WEBPACK FOOTER //
// ./src/DefaultState.js